import { useState, useEffect, useRef } from "react";
const testimonials = [{
  col: 0,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/user-1.jpg",
  name: "Rafaela J.",
  role: "Small Business Staff Member",
  review: "10Web has the main features for a website to be build and the generation is very easy using AI. Our clients are loving and for us as a company is easy to implement.",
  date: "Mar 18, 2024"
}, {
  col: 0,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/user-4.jpg",
  name: "Sharukesh S.",
  role: "Market Research Analyst",
  review: "The AI builder does everything for you. All you have to do is prompt. It also optimizes for SEO and has easy to use Wordpress plugins. The best part is the price - which for most is really affordable.",
  date: "Sep 04, 2023"
}, {
  col: 1,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/user-2.jpg",
  name: "Ashot K.",
  role: "Full Stack Developer",
  review: "It has a clean interface and free magic speed optimization tool inbuilt.",
  date: "Mar 29, 2022"
}, {
  col: 1,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/user-5.jpg",
  name: "David E.",
  role: "Owner/ CEO",
  review: "Within minutes of the onboarding process, I was able to create a great, professional-looking WordPress website without the need to hire a developer. The AI generated website is beautiful and I can use Elementor, a tool I know and trust, to make stylistic changes.",
  date: "Feb 20, 2021"
}, {
  col: 2,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/user-3.jpg",
  name: "Elizabeth J.",
  role: "Small Business Staff Member",
  review: "You guys, no other platform on the market with similar products comes anywhere near 10Web. They combine AI capabilities, ease of use, and reliable hosting in a magical way.",
  date: "May 03, 2023"
}, {
  col: 2,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/user-6.jpg",
  name: "Mark U.",
  role: "Senior Test Analyst",
  review: `I've heard about 10Web before but the true "test time" started when I began using it. Absolutely the best and most reliable service, am very happy with 10Web! And the ease-of-use is simply off the charts!`,
  date: "Sep 15, 2020"
}];
const col0 = testimonials.filter(t => t.col === 0);
const col1 = testimonials.filter(t => t.col === 1);
const col2 = testimonials.filter(t => t.col === 2);
function TestimonialCard({
  avatar,
  name,
  role,
  review,
  date,
  delay
}: {
  avatar: string;
  name: string;
  role: string;
  review: string;
  date: string;
  delay: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <div ref={ref} className="flex flex-col" style={{
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0px 2px 12px rgba(0,0,0,0.06)",
    padding: "28px",
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0px)" : "translateY(30px)",
    transition: `opacity 0.5s cubic-bezier(0.12, 0.23, 0.5, 1) ${delay}ms, transform 0.5s cubic-bezier(0.12, 0.23, 0.5, 1) ${delay}ms`
  }}>
      <div className="flex flex-row items-center" style={{
      gap: "12px"
    }}>
        <img src={avatar} alt={name} className="flex-shrink-0" style={{
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        objectFit: "cover"
      }} />
        <div className="flex flex-col">
          <p style={{
          color: "rgb(20, 21, 31)",
          fontFamily: '"Evergrow Sans", sans-serif',
          fontSize: "14px",
          fontWeight: "700",
          lineHeight: "20px",
          border: "0px none rgb(20, 21, 31)",
          animation: "none 0s ease 0s 1 normal none running",
          margin: 0
        }}>
            {name}
          </p>
          <p style={{
          color: "rgba(0, 0, 0, 0.5)",
          fontFamily: '"Evergrow Sans", sans-serif',
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "20px",
          border: "0px none rgba(0, 0, 0, 0.5)",
          animation: "none 0s ease 0s 1 normal none running",
          margin: 0
        }}>
            {role}
          </p>
        </div>
      </div>
      
      <p style={{
      color: "rgba(0, 0, 0, 0.5)",
      fontFamily: '"Evergrow Sans", sans-serif',
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "20px",
      border: "0px none rgba(0, 0, 0, 0.5)",
      animation: "none 0s ease 0s 1 normal none running",
      marginTop: "16px",
      marginBottom: "0px"
    }}>
        {date}
      </p>
    </div>;
}
export default function TestimonialsSection() {
  return;
}